import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { ItemProps } from 'components/Blocks/Product/CategoryPromotedProducts/Item/Item';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useCallback } from 'react';
import { ListedProductType } from 'types/product';
import { onClickProductDetailGtmEventHandler } from 'utils/Gtm/EventHandlers';

export const ProductLink: FC<ItemProps> = ({ gtmListName, item, listIndex }) => {
    const domainConfig = useDomainConfig();

    const onProductClickHandler = useCallback(
        (product: ListedProductType, index: number) => () => {
            onClickProductDetailGtmEventHandler(product, gtmListName, index, domainConfig.url);
        },
        [gtmListName, domainConfig.url],
    );

    return (
        <ExtendedNextLink
            type="product"
            href={item.slug}
            className="text-small font-medium leading-5 tracking-wider text-primary no-underline hover:text-primary hover:no-underline"
            onClick={onProductClickHandler(item, listIndex)}
        >
            <span>{item.fullName}</span>
        </ExtendedNextLink>
    );
};
